/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Top_Best_Ostrich_PickInputs */

const fr_top_best_ostrich_pick = /** @type {(inputs: Top_Best_Ostrich_PickInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choisissez où cette catégorie sera visible`)
};

/**

* @param {Top_Best_Ostrich_PickInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const top_best_ostrich_pick = /** @type {((inputs?: Top_Best_Ostrich_PickInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Top_Best_Ostrich_PickInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_top_best_ostrich_pick(inputs)
});